<template>
  <div id="tree-map">
    <apexchart
      type="treemap"
      height="350"
      :options="chartOptions"
      :series="chartSeries"
    ></apexchart>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts'

export default {
  components: {
    apexchart: VueApexCharts,
  },
  props: {
    series: {
      type: Array,
      default: () => [],
    },
    nivel: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      chartSeries: [],
      chartOptions: {},
    }
  },
  created() {
    this.chartOptions = {
      chart: {
        type: 'treemap',
        height: 350,
        events: {
          dataPointMouseEnter: function (event) {
            event.target.style.cursor = 'pointer'
          },
          dataPointSelection: (event, chartContext, config) => {
            const item = config.w.config.series[0].data[config.dataPointIndex]
            this.$emit('openModal', item) // envia o objeto { x, y }
          },
        },
      },
      colors: ['#1212B6', '#38BA38', '#D5BA0A', '#C46500'],
      plotOptions: {
        treemap: {
          distributed: true,
          enableShades: false,
        },
      },
      tooltip: {
        y: {
          formatter: (value) => {
            let tipo = ''
            if (this.nivel == '2') {
              tipo = 'equipes'
            }
            if (this.nivel == '3') {
              tipo = 'microáreas'
            }
            return value + ` ${tipo}`
          },
        },
      },
      dataLabels: {
        enabled: true,
        formatter: function (text, op) {
          const value = op.value
          return `${value}`
        },
        style: {
          fontSize: '22px',
          fontWeight: 'bold',
        },
      },
      legend: { show: false },
      title: { text: '', align: 'center' },
    }
  },
  watch: {
    series: {
      handler(newValue) {
        const ordemDesejada = ['Ótimo', 'Bom', 'Suficiente', 'Regular']
        const corPorClassificacao = {
          Ótimo: '#1212B6',
          Bom: '#38BA38',
          Suficiente: '#D5BA0A',
          Regular: '#C46500',
        }

        let qtd = ''
        if (this.nivel == '2') {
          qtd = 'qtd_equipes'
        }
        if (this.nivel == '3') {
          qtd = 'qtd_micro_areas'
        }

        // Cria um mapa com os dados recebidos
        const mapaDados = newValue.reduce((acc, el) => {
          acc[el.classificacao] = el[qtd]
          return acc
        }, {})

        // Garante que todas as classificações existam, mesmo que com 0
        const dadosCompletos = ordemDesejada.map((classificacao) => ({
          x: classificacao,
          y: mapaDados[classificacao] || 0,
        }))

        // Atualiza a série e as opções
        this.chartSeries = [{ data: dadosCompletos }]
        this.chartOptions.labels = ordemDesejada
        this.chartOptions.colors = ordemDesejada.map(
          (c) => corPorClassificacao[c]
        )
      },
      deep: true,
      immediate: true,
    },
  },
}
</script>
